import { Box, Button, ButtonColorVariant, GridDisplay } from '@gousto-internal/citrus-react'
import React from 'react'

type OrderTileActionsProps = {
  helpCta: string | null
  isManageDeliveryExpanded: boolean
  onGetHelpClick: () => void
  onManageDeliveryClick: () => void
}

export const OrderTileActions = ({
  helpCta,
  isManageDeliveryExpanded,
  onGetHelpClick,
  onManageDeliveryClick,
}: OrderTileActionsProps) => (
  <Box
    display={GridDisplay.Grid}
    gridTemplateColumns={['1fr', '1fr', 'repeat(2, minmax(0, 1fr))']}
    gap={4}
  >
    {helpCta ? (
      <Button colorVariant={ButtonColorVariant.Secondary} onClick={onGetHelpClick} width="100%">
        {helpCta}
      </Button>
    ) : null}
    <Box display={['none', 'none', 'block']}>
      <Button
        colorVariant={ButtonColorVariant.Tertiary}
        onClick={onManageDeliveryClick}
        width="100%"
        afterIcon={isManageDeliveryExpanded ? 'chevron_up' : 'chevron_down'}
      >
        Manage delivery
      </Button>
    </Box>
  </Box>
)
